export default __webpack_public_path__ + "static/media/k1.79fd59f7.jpg";